import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"],
  _excluded7 = ["children"],
  _excluded8 = ["children"],
  _excluded9 = ["title", "children"];
import { Box, Text, Loader, IconButton } from '@wix/design-system';
import React from 'react';
import { useIsHarmonyTheme } from '../../context/HarmonyTheme';
const SharedContainerProps = {
  direction: 'vertical',
  backgroundColor: '#FFFFFF',
  maxWidth: '985px',
  width: '100%'
};
export const CoreDomainSearchBaseLayout = {
  // Section Containers
  SearchContainer: _ref => {
    let children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/React.createElement(Box, _extends({
      zIndex: 1,
      borderRadius: "12px"
    }, SharedContainerProps, props), children);
  },
  StatusContainer: _ref2 => {
    let children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return /*#__PURE__*/React.createElement(Box, _extends({}, SharedContainerProps, {
      backgroundColor: "transparent"
    }, props), children);
  },
  StatusComponent: () => null,
  InputContainer: _ref3 => {
    let children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
    const isHarmonyTheme = useIsHarmonyTheme();
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "horizontal",
      verticalAlign: "middle",
      width: "100%",
      padding: isHarmonyTheme ? 'SP3 SP3 SP3 SP2' : '6px SP3 6px SP2',
      flex: 1,
      gap: "SP1"
    }, props), children);
  },
  ClearFiltersContainer: _ref4 => {
    let children = _ref4.children,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded4);
    return /*#__PURE__*/React.createElement(Box, _extends({
      verticalAlign: "middle"
    }, props), children);
  },
  ToolBarContainer: _ref5 => {
    let children = _ref5.children,
      props = _objectWithoutPropertiesLoose(_ref5, _excluded5);
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "horizontal",
      gap: "SP5",
      verticalAlign: "middle",
      flexWrap: "wrap",
      width: "100%",
      zIndex: 1
    }, props), children);
  },
  AdditionalToolsContainer: _ref6 => {
    let children = _ref6.children,
      props = _objectWithoutPropertiesLoose(_ref6, _excluded6);
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "horizontal",
      gap: "SP2",
      verticalAlign: "middle",
      flex: 1
    }, props), children);
  },
  ErrorContainer: _ref7 => {
    let children = _ref7.children,
      props = _objectWithoutPropertiesLoose(_ref7, _excluded7);
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "vertical",
      gap: "SP2",
      padding: "SP4",
      backgroundColor: "#FFF5F5",
      borderRadius: "8px",
      border: "1px solid #FEB2B2"
    }, props), children);
  },
  // UI Elements
  LoadingIndicator: _ref8 => {
    let _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? 'medium' : _ref8$size;
    return /*#__PURE__*/React.createElement(Box, {
      align: "center",
      padding: "SP4"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: size
    }));
  },
  ActionButton: _ref9 => {
    let children = _ref9.children,
      props = _objectWithoutPropertiesLoose(_ref9, _excluded8);
    return /*#__PURE__*/React.createElement(IconButton, props, children);
  },
  // Specialized Containers
  FilterGroup: _ref0 => {
    let title = _ref0.title,
      children = _ref0.children,
      props = _objectWithoutPropertiesLoose(_ref0, _excluded9);
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "vertical",
      gap: "SP2"
    }, props), title && /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "bold"
    }, title), /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "SP2"
    }, children));
  }
};
//# sourceMappingURL=CoreDomainSearchBaseLayout.js.map